import {CompetitorPageMetaDataModel} from "../../../models/competitor-page.meta-data.model";
import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";

export class CompetitorNewsPageRouteMetaDataModel extends CompetitorPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITOR.news)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITOR.news)
    }

    return description
  }

  get staticTitle() {
    const title = this.websiteTerms.META_TITLE_COMPETITOR_NEWS.format({
      "COMPETITOR_NAME": this.competitorName,
      "SPORT_TYPE": this.competitorSportName
    });
    return this.titleFormatTerm(title);
  }

  get staticDescription() {
    const description = this.websiteTerms.META_DESCRIPTION_COMPETITOR_NEWS.format({
      "COMPETITOR_NAME": this.competitorName,
      "SPORT_TYPE": this.competitorSportName
    });

    return this.descriptionFormatTerm(description);
  }
}